import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Alert } from 'reactstrap';
import FormCard from '../forms/FormCard';
import Grid from '../grid/Grid';
import { SingleFileUploader } from '../forms/SingleFileUploader';
import * as api from '../../api';
import { isNovertejumsEditableByUser, parseListResult } from './riskaNovertejumsUtils';
import {
    loadRiskaNovertejumuDokumenti,
    loadRiskaNovertejums
} from '../../actions/dzeramaUdensSatecesBaseiniActions';

class RiskaNovertejumsDokumenti extends Component {
    state = {
        dokumenti: [],
        uploadingDocument: false,
        uploadError: null
    };

    componentDidMount() {
        this.loadDokumenti();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.id !== this.props.id) {
            this.loadDokumenti();
        }
    }

    loadDokumenti = () => {
        const { id, loadRiskaNovertejumuDokumenti } = this.props;
        if (id) {
            loadRiskaNovertejumuDokumenti(id).then(result => {
                this.setState({ dokumenti: parseListResult(result) });
            }).catch(() => {});
        }
    }

    handleDocumentUpload = (fileInfo) => {
        const { id, loadRiskaNovertejums } = this.props;
        this.setState({ uploadingDocument: true, uploadError: null });

        api.saveApi('riska_novertejumu_dokumenti_view', {
            riska_novertejumi_id: id,
            file_info_id: fileInfo.id
        }).then(() => {
            this.setState({ uploadingDocument: false });
            this.loadDokumenti();
            loadRiskaNovertejums(id);
        }).catch((error) => {
            this.setState({
                uploadingDocument: false,
                uploadError: 'Kļūda augšupielādējot dokumentu: ' + (error.message || error)
            });
        });
    }

    handleDocumentDelete = (documentId) => {
        if (!window.confirm('Vai tiešām vēlaties dzēst šo dokumentu?')) return;

        const { id, loadRiskaNovertejums } = this.props;
        api.deleteApi('riska_novertejumu_dokumenti_view', documentId)
            .then(() => {
                this.loadDokumenti();
                loadRiskaNovertejums(id);
            })
            .catch((error) => {
                alert('Kļūda dzēšot dokumentu: ' + error.message);
            });
    }

    getDokumentiColumns = () => {
        const { novertejums } = this.props;
        const isEditable = isNovertejumsEditableByUser(novertejums, this.props.user?.tiesibas);

        const columns = [
            {
                dataField: 'filename',
                text: 'Faila nosaukums',
                sort: true,
                formatter: (cell, row) => (
                    <a href={`/services/download/${row.file_info_id}/${row.sha_256}`} className="btn btn-link p-0">
                        <i className="fa fa-download mr-2"></i>
                        {cell}
                    </a>
                )
            },
            {
                dataField: 'upload_time',
                text: 'Augšupielādēts',
                sort: true,
                formatter: (cell) => cell ? new Date(cell).toLocaleString('lv-LV') : ''
            }
        ];

        if (isEditable) {
            columns.push({
                dataField: 'df1',
                text: '',
                isDummyField: true,
                formatter: (_cellContent, row) => (
                    <Button
                        color="danger"
                        size="sm"
                        onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            this.handleDocumentDelete(row.id);
                        }}
                    >
                        <i className="fa fa-trash"></i>
                    </Button>
                ),
                width: 60,
                sort: false,
                classes: 'td-button'
            });
        }

        return columns;
    }

    render() {
        const { novertejums, kodif, id } = this.props;
        const { uploadingDocument, uploadError, dokumenti } = this.state;

        if (!novertejums) {
            return <Alert color="info">Nav datu</Alert>;
        }

        const isEditable = isNovertejumsEditableByUser(novertejums, this.props.user?.tiesibas);
        const smallFileLimit = kodif?.FILES?.MAX_SIZE_MB ? kodif.FILES.MAX_SIZE_MB * 1024 * 1024 : 10 * 1024 * 1024;

        return (
            <FormCard title="Dokumenti" size={12}>
                {isEditable && (
                    <div className="mb-3">
                        <h6>Pievienot dokumentu</h6>
                        <SingleFileUploader
                            limit={smallFileLimit}
                            onFileUploaded={this.handleDocumentUpload}
                        />
                        {uploadingDocument && (
                            <Alert color="info" className="mt-2">Saglabā dokumentu...</Alert>
                        )}
                        {uploadError && (
                            <Alert color="danger" className="mt-2">{uploadError}</Alert>
                        )}
                    </div>
                )}

                {dokumenti.length > 0 ? (
                    <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
                        <Grid
                            dataList={dokumenti}
                            totalCount={dokumenti.length}
                            columns={this.getDokumentiColumns()}
                            enablePaging={false}
                            defaultSorted={[{ dataField: 'upload_time', order: 'desc' }]}
                            exportViewname="riska_novertejumu_dokumenti_view"
                            exportQuery={{ riska_novertejumi_id: id }}
                        />
                    </div>
                ) : (
                    <Alert color="info">Nav pievienots neviens dokuments</Alert>
                )}
            </FormCard>
        );
    }
}

const mapStateToProps = (state) => ({
    novertejums: (state.riskaNovertejumi || {}).selectedItem,
    kodif: state.kodif || {},
    user: state.user || {}
});

export default connect(mapStateToProps, {
    loadRiskaNovertejumuDokumenti,
    loadRiskaNovertejums
})(RiskaNovertejumsDokumenti);
